import {GetOpenObligationList} from 'domain/usecases';
import {RemoteGetOpenObligationList} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetOpenObligationList = (): GetOpenObligationList =>
	new RemoteGetOpenObligationList(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.payments),
		makeAuthorizeHttpClientDecorator(),
	);
